import { FC } from 'react';

export const Email: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2 7C2 5.34315 3.34315 4 5 4H19C20.6505 4 21.9896 5.3328 21.9999 6.98083C22.0001 6.99178 22.0002 7.00274 22 7.01368V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7ZM19.8879 6.53954C19.7213 6.21897 19.3862 6 19 6H5C4.61376 6 4.27867 6.21897 4.11209 6.53954L12 11.7981L19.8879 6.53954ZM4 8.86852L10.8906 13.4622C11.5624 13.9101 12.4376 13.9101 13.1094 13.4622L20 8.86852V17C20 17.5523 19.5523 18 19 18H5C4.44772 18 4 17.5523 4 17V8.86852Z"
			fill="currentColor"
		/>
	</svg>
);
